module.exports = __webpack_public_path__ + "static/media/02_led-matrix-module.91d14bf1.mp4";